import { Group } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { exportMultiReport } from "../../../../services/report";
import { useSelectFiltersForMonitoring } from "../../../../redux/features/reports/forMonitoringSlice";
import { REPORT_EXPORT_TYPE, REPORT_TYPES } from "../../constants";
import ExportFileButton from "../../../../components/ExportFileButton/ExportFileButton";

const stripEmpty = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, v]) => v !== "" && v !== null && v !== undefined,
    ),
  );

const downloadBlobResponse = (response) => {
  const fileName =
    response.headers["content-disposition"]?.split("filename=")[1] ||
    "for-monitoring-report";

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};

const ExportForMonitoringReports = () => {
  const { t } = useTranslation();
  const [currentType, setCurrentType] = useState(null);

  const filters = stripEmpty(useSelectFiltersForMonitoring());

  const downloadFile = useMutation({
    mutationKey: ["for-monitoring-report-download-file"],
    mutationFn: (reportExportType) =>
      exportMultiReport({
        type: REPORT_TYPES.FOR_MONITORING,
        forExport: true,
        reportExportType,
        ...filters,
      }),
    onSuccess: downloadBlobResponse,
    onError: ({ message }) => {
      toast.error("Export error " + message);
    },
  });

  const handleDownload = async (option) => {
    setCurrentType(option);
    await downloadFile.mutateAsync(option);
    setCurrentType(null);
  };

  const loading = downloadFile.isPending;

  return (
    <Group>
      <ExportFileButton
        handleDownload={() => handleDownload(REPORT_EXPORT_TYPE.PDF)}
        disabled={loading}
        loading={loading && currentType === REPORT_EXPORT_TYPE.PDF}
        tooltipLabel={t("reports.exportPdf")}
        type={REPORT_EXPORT_TYPE.PDF}
      />
      <ExportFileButton
        handleDownload={() => handleDownload(REPORT_EXPORT_TYPE.EXCEL)}
        disabled={loading}
        loading={loading && currentType === REPORT_EXPORT_TYPE.EXCEL}
        tooltipLabel={t("reports.exportExcel")}
        type={REPORT_EXPORT_TYPE.EXCEL}
      />
    </Group>
  );
};

export default ExportForMonitoringReports;
